// extracted by mini-css-extract-plugin
export default {"navItem":"PlaceNavItem_navItem__qNnA0","navLink":"PlaceNavItem_navLink__3vXbk"};